// Re-exports from unified color system
import { PRIMITIVE_COLORS } from '../residentColors';

export const PAYMENT_COLORS = {
  SUCCESS_GREEN: PRIMITIVE_COLORS.successGreenBright,
  SUCCESS_GREEN_LIGHT: PRIMITIVE_COLORS.successGreenLight,
  ERROR_RED: PRIMITIVE_COLORS.resioRed,
  WARNING_ORANGE: PRIMITIVE_COLORS.warningYellow,
  WHITE: PRIMITIVE_COLORS.white,
  GRAY_LIGHT: PRIMITIVE_COLORS.gray100,
  GRAY_MEDIUM: '#E5E5EA',
  BLUE_LIGHT: '#EBF4FF',
  TEXT_PRIMARY: PRIMITIVE_COLORS.black,
  TEXT_SECONDARY: PRIMITIVE_COLORS.white,
  TEXT_TERTIARY: '#8E8E93',
} as const;
